import { logDevError } from "./backends/log-dev-error";
import { EVENT_NAME_PATTERN, MAX_EVENT_NAME_LENGTH } from "./ingest-limits";

export interface CheckedEvent {
  eventName: string;
  data: Record<string, unknown> | undefined;
}

/**
 * The runtime half of the name check (policy rule 2; `EventName` is the
 * type-level half). A bad name is not sent as-is, where ingest would drop it
 * behind a 2xx, and not thrown on: it is reported as
 * `infra.log.invalid_event_name`, carrying the one it replaced, and said out
 * loud in the console. An untyped caller can pass a non-string, which is
 * reported by its typeof, never stringified: its toString may throw too.
 */
export function checkEventName(
  emitter: string,
  eventName: unknown,
  data: Record<string, unknown> | undefined,
): CheckedEvent {
  if (
    typeof eventName === "string" &&
    eventName.length <= MAX_EVENT_NAME_LENGTH &&
    EVENT_NAME_PATTERN.test(eventName)
  ) {
    return { eventName, data };
  }
  const shown =
    typeof eventName === "string"
      ? eventName.slice(0, MAX_EVENT_NAME_LENGTH)
      : `<${eventName === null ? "null" : typeof eventName}>`;
  logDevError(
    emitter,
    "event name",
    `"${shown}" is not domain.action-shaped within ${String(MAX_EVENT_NAME_LENGTH)} characters`,
  );
  return {
    eventName: "infra.log.invalid_event_name",
    data: {
      invalid_event_name: shown,
      ...(data === undefined ? {} : { data }),
    },
  };
}
